import React from 'react';
import { Box, Button, Card, CardBody, Heading, HStack, SimpleGrid, Spinner, Text, VStack } from '@chakra-ui/react';

const ORDERED_MEMBERS = ['AIRPORTS', 'AVIATION_SERVICES', 'DESTINATION', 'HOSPITALITY', 'RETAIL', 'TOURISM_DEVELOPMENT'];

const ByMemberGrid = ({ isInj, userMember, loading, dashboardData, memberLogos, formatNumber, formatCurrency, onDetailClick }) => (
  <Card
    bg="rgba(255, 255, 255, 0.86)"
    borderRadius="18px"
    boxShadow="0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.04)"
    border="1px solid"
    borderColor="rgba(0, 0, 0, 0.06)"
    mb={6}
  >
    <CardBody>
      <Heading size="md" mb={4} color="rgba(0, 0, 0, 0.85)" letterSpacing="-0.3px">
        By Member
      </Heading>
      {loading ? (
        <Spinner />
      ) : (
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3, xl: 6 }} spacing={4}>
          {(isInj ? ORDERED_MEMBERS : userMember ? [userMember] : []).map((member) => {
            const data = dashboardData.byMember[member] || { numTrx: 0, grossAmount: 0, netAmount: 0 };
            const displayName = member.replace(/_/g, ' ');
            const logoPath = memberLogos[member];
            return (
              <Card key={member} bg="white" borderRadius="14px" border="1px solid" borderColor="rgba(0, 0, 0, 0.08)" boxShadow="0 4px 12px rgba(0, 0, 0, 0.05)" display="flex" flexDirection="column">
                <CardBody display="flex" flexDirection="column" flex={1} p={3}>
                  <VStack spacing={2} align="stretch" flex={1}>
                    <HStack spacing={2.5} align="center">
                      <Box w="42px" h="42px" bg="white" borderRadius="8px" display="flex" alignItems="center" justifyContent="center" boxShadow="sm" overflow="hidden">
                        {logoPath ? (
                          <img
                            src={logoPath}
                            alt={displayName}
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'flex';
                            }}
                          />
                        ) : null}
                        <Box display={logoPath ? 'none' : 'flex'} alignItems="center" justifyContent="center" w="100%" h="100%">
                          <Text fontSize="xs" fontWeight="700" color="gray.600">
                            {displayName.substring(0, 2)}
                          </Text>
                        </Box>
                      </Box>
                      <Text fontSize="sm" fontWeight="700" color="rgba(0, 0, 0, 0.78)" lineHeight="1.2">
                        {displayName}
                      </Text>
                    </HStack>
                    <VStack spacing={1} align="stretch" flex={1}>
                      <HStack justify="space-between">
                        <Text fontSize="xs" color="gray.600">Transaction</Text>
                        <Text fontSize="13px" fontWeight="700" color="rgba(0, 0, 0, 0.85)" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                          {data.numTrx > 0 ? formatNumber(data.numTrx) : '--'}
                        </Text>
                      </HStack>
                      <HStack justify="space-between">
                        <Text fontSize="xs" color="gray.600">Gross</Text>
                        <Text fontSize="13px" fontWeight="700" color="rgba(0, 0, 0, 0.85)" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                          {data.grossAmount !== undefined && data.grossAmount !== null ? formatCurrency(data.grossAmount) : '--'}
                        </Text>
                      </HStack>
                      <HStack justify="space-between">
                        <Text fontSize="xs" color="gray.600">Net</Text>
                        <Text fontSize="13px" fontWeight="700" color="rgba(0, 0, 0, 0.85)" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                          {data.netAmount !== undefined && data.netAmount !== null ? formatCurrency(data.netAmount) : '--'}
                        </Text>
                      </HStack>
                    </VStack>
                  </VStack>
                  {isInj && (
                    <Button size="xs" h="24px" minH="24px" fontSize="11px" fontWeight="600" px={2.5} borderRadius="8px" colorScheme="blue" onClick={() => onDetailClick(member)} mt={2.5} width="100%">
                      Detail
                    </Button>
                  )}
                </CardBody>
              </Card>
            );
          })}
        </SimpleGrid>
      )}
    </CardBody>
  </Card>
);

export default ByMemberGrid;
